import type { ReactNode } from "react";
import { SiteHeader } from "./SiteHeader";
import { SiteFooter } from "./SiteFooter";
import { BackToTop } from "./BackToTop";

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader />
      <main id="main" tabIndex={-1}>{children}</main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}

export function PageHero({
  eyebrow,
  title,
  description,
}: {
  eyebrow: string;
  title: ReactNode;
  description?: ReactNode;
}) {
  return (
    <section className="relative pt-40 pb-20 border-b border-border bg-surface">
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="container-page relative">
        <div className="max-w-4xl">
          <span className="eyebrow">{eyebrow}</span>
          <h1 className="mt-5 text-balance text-5xl md:text-7xl font-semibold tracking-tight leading-[0.95]">
            {title}
          </h1>
          {description && (
            <p className="mt-6 max-w-2xl text-pretty text-lg text-ink-soft leading-relaxed">
              {description}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
